import ABKAccordion from "../../../../global/components/ABKAccordionAlt";
import {AccordionData} from "../../../../global/interfaces/AccordionData";
import useClientQuery from "../../../../global/queries/useClientQuery";


const ABKDataAccordion = () => {

    const {data: client} = useClientQuery();

    const abkData: AccordionData[] = [
        {label: "ABK-Nummer", size: 6, value: client?.nummer},
        {label: "Wartungsvertrag", size: 6, value: client?.wartungsvertrag},
        {label: "Lizenzschlüssel", size: 6, value: client?.xkukennwort},
        {label: "Lizenzierte Version", size: 6, value: client?.lizenzierteVersion}
    ]

    return <ABKAccordion isInput={false} accordionTitle={"ABK-Daten"} data={abkData} />
}

export default ABKDataAccordion;